import { render, staticRenderFns } from "./Chat.html?vue&type=template&id=53ea3fa4&scoped=true&external"
import script from "./Chat.js?vue&type=script&lang=js&external"
export * from "./Chat.js?vue&type=script&lang=js&external"
import style0 from "./Chat.vue?vue&type=style&index=0&id=53ea3fa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ea3fa4",
  null
  
)

export default component.exports